import EntityBase from '@/data/EntityBase';

export default class ShiftHistoryState extends EntityBase({}) {}
